var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoftTeamsLogoIcon = function SvgMicrosoftTeamsLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none",
    viewBox: "0 0 22 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MicrosoftTeamsLogoIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5059C9",
    d: "M15.345 7.939h5.683c.537 0 .972.436.972.973v5.182c0 1.976-1.6 3.577-3.573 3.577h-.017a3.575 3.575 0 0 1-3.573-3.576V8.447c0-.281.228-.51.508-.51M19.186 6.915a2.304 2.304 0 0 0 2.302-2.305 2.304 2.304 0 0 0-2.302-2.305 2.304 2.304 0 0 0-2.302 2.305 2.304 2.304 0 0 0 2.302 2.305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B83EB",
    d: "M12.023 6.915a3.327 3.327 0 0 0 3.326-3.33 3.327 3.327 0 0 0-3.326-3.33 3.33 3.33 0 0 0-3.325 3.33 3.33 3.33 0 0 0 3.325 3.33M16.458 7.939h-9.38a.96.96 0 0 0-.938.985v5.91a5.774 5.774 0 0 0 5.627 5.91 5.774 5.774 0 0 0 5.628-5.91v-5.91a.963.963 0 0 0-.937-.985"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.279 7.939v8.282a.943.943 0 0 1-.936.938H6.59a6.246 6.246 0 0 1-.45-2.325V8.921a.96.96 0 0 1 .936-.983z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.767 7.939v8.795a.942.942 0 0 1-.936.937h-4a7 7 0 0 1-.241-.512 6.246 6.246 0 0 1-.45-2.325V8.921a.96.96 0 0 1 .936-.983z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.767 7.939v7.77a.944.944 0 0 1-.936.938h-4.42a6.3 6.3 0 0 1-.272-1.814v-5.91a.96.96 0 0 1 .937-.984z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.256 7.939v7.77a.944.944 0 0 1-.937.938H6.411a6.3 6.3 0 0 1-.272-1.814v-5.91a.96.96 0 0 1 .937-.984z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.28 5.29v1.614c-.088.005-.17.01-.257.01s-.168-.005-.255-.01a3 3 0 0 1-.512-.082 3.33 3.33 0 0 1-2.302-1.956 3 3 0 0 1-.164-.513h2.553a.94.94 0 0 1 .936.938",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.768 5.803v1.101a3 3 0 0 1-.512-.082 3.33 3.33 0 0 1-2.302-1.956h1.877a.94.94 0 0 1 .937.937",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.768 5.803v1.101a3 3 0 0 1-.512-.082 3.33 3.33 0 0 1-2.302-1.956h1.877a.94.94 0 0 1 .937.937",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.256 5.803v1.02a3.33 3.33 0 0 1-2.303-1.957h1.366a.94.94 0 0 1 .937.937",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#MicrosoftTeamsLogoIcon_svg__b)",
    d: "M.938 4.866h9.38c.518 0 .938.42.938.939v9.39c0 .519-.42.94-.938.94H.938a.94.94 0 0 1-.938-.94v-9.39c0-.519.42-.94.938-.94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.096 8.44H6.221v5.112H5.026V8.44H3.16v-.992h4.936z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MicrosoftTeamsLogoIcon_svg__b",
    x1: 1.955,
    x2: 9.313,
    y1: 4.132,
    y2: 16.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MicrosoftTeamsLogoIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .256h22v20.489H0z"
  })))));
};
export default SvgMicrosoftTeamsLogoIcon;